import { render, staticRenderFns } from "./tharm-result.vue?vue&type=template&id=edbbb754&scoped=true"
import script from "./tharm-result.vue?vue&type=script&lang=js"
export * from "./tharm-result.vue?vue&type=script&lang=js"
import style0 from "./tharm-result.vue?vue&type=style&index=0&id=edbbb754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbbb754",
  null
  
)

export default component.exports